import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useSocket } from "../contexts/SocketProvider";

function SocketLog() {
  const [channel, setChannel] = useState("");
  const [subscription, setSubscription] = useState(null);
  const { socket, isConnected } = useSocket();

  const logMessage = (message) => {
    console.log("Received: ", message);
  };

  return (
    <>
      <div>SocketLog</div>
      <Form>
        <Form.Group className="mb-3" controlId="channel">
          <Form.Label>Channel:</Form.Label>
          <Form.Control
            type="text"
            autoComplete="off"
            onChange={(e) => setChannel(e.target.value)}
            value={channel}
            disabled={subscription != null}
          />
        </Form.Group>
        <Button
          type="button"
          variant="primary"
          disabled={isConnected && subscription != null}
          onClick={() => {
            console.log(`subscribing to ${channel}`);
            if (socket != null) {
              const sub = socket.subscribe(`${channel}`, logMessage);
              setSubscription(sub);
            }
          }}
        >
          Connect
        </Button>
        <Button
          type="button"
          variant="danger"
          disabled={isConnected && subscription == null}
          onClick={() => {
            console.log("Removing subscription");
            if (subscription != null) {
              subscription.unsubscribe();
              setSubscription(null);
            }
            setChannel("");
          }}
        >
          Stop
        </Button>
      </Form>
    </>
  );
}

export default SocketLog;
